<template>
  <div>
    <div
      ref="navbar"
      class="navbar"
      :class="{active: isNavActive}"
    >
      <a
        id="logo"
        href="/"
      >
        <img src="@/assets/m_img_logo@2x.png" />
      </a>
      <ul class="menu menu-horizontal">
        <router-link
          exact
          tag="li"
          class="menu-item"
          active-class="menu-item-selected"
          to="/?anchorIndex=0"
          @mouseenter.native="handleMenuMouseEnter()"
        >首页</router-link>

        <li
          class="menu-item menu-submenu"
          :class="{'menu-item-selected': isNavActiveOfProduct}"
          ref="product"
          @mouseenter="handleMenuMouseEnter('product', 'menu-submenu-popup__product')"
          @click.stop="handleMenuMouseEnter('product', 'menu-submenu-popup__product')"
        >
          产品与服务
        </li>

        <router-link
          exact
          tag="li"
          class="menu-item"
          active-class="menu-item-selected"
          to="/case"
          @mouseenter.native="handleMenuMouseEnter()"
        >案例</router-link>

        <router-link
          exact
          tag="li"
          class="menu-item"
          active-class="menu-item-selected"
          to="/?anchorIndex=3"
          @mouseenter.native="handleMenuMouseEnter()"
        >关于我们</router-link>
        <li
          class="menu-item more-box"
          ref="more-box"
          @mouseenter="handleMenuMouseEnter('more-box', 'menu-submenu-popup__more-box')"
          @click.stop="handleMenuMouseEnter('more-box', 'menu-submenu-popup__more-box')"
        >
          <img
            class="more-box-img"
            src="@/assets/icon_entrance@2x.png"
          />
        </li>
      </ul>
      <div
        ref="menu-submenu-popup__product"
        class="menu-submenu menu-submenu-popup menu-submenu-popup-serve"
        @mouseenter="handleMenuMouseEnter('product', 'menu-submenu-popup__product')"
        @mouseleave="handleSubmenuMouseLeave('menu-submenu-popup__product')"
      >
        <ul
          class="menu"
          style="display: flex;"
        >
          <li class="icon-li icon-li01"></li>
          <router-link
            tag="li"
            class="menu-item son-item"
            to="/keyCustomers"
          >充电大客户</router-link>
          <router-link
            tag="li"
            class="menu-item son-item"
            to="/chargingFranchise"
          >充电加盟</router-link>
          <router-link
            tag="li"
            class="menu-item son-item"
            to="/intelligentlogistics"
          >充电投资</router-link>
        </ul>
        <ul
          class="menu menu2"
          style="display: flex;"
        >
          <li class="icon-li icon-li02"></li>
          <router-link
            tag="li"
            class="menu-item son-item"
            to="/transportationEnterprises"
          >运力企业</router-link>
          <router-link
            tag="li"
            class="menu-item son-item"
            to="/individualDriver"
          >个体司机</router-link>
          <router-link
            tag="li"
            class="menu-item son-item"
            to="/consignor"
          >货主</router-link>
          <router-link
            tag="li"
            class="menu-item son-item"
            to="/parkServices"
          >园区</router-link>
        </ul>
      </div>
      <div
        ref="menu-submenu-popup__more-box"
        class="menu-submenu menu-submenu-popup"
        @mouseenter="handleMenuMouseEnter('more-box', 'menu-submenu-popup__more-box')"
        @mouseleave="handleSubmenuMouseLeave('menu-submenu-popup__more-box')"
      >
        <ul class="menu">
          <a
                  href="https://sgn.aostarit.com.cn/ec/index.html"
                  target="_blank"
          >
            <li class="menu-item">
              绿色智慧物流系统
            </li>
          </a>
          <a
            href="https://sgn.aostarit.com.cn/opt/index.html"
            target="_blank"
          >
            <li class="menu-item">
              绿色智慧物流管理系统
            </li>
          </a>
          <a
            href="https://sgn.aostarit.com.cn/icity-bigdata/index.html"
            target="_blank"
          >
            <li class="menu-item">
              绿色智慧物流数据系统
            </li>
          </a>
        </ul>
      </div>
    </div>
    <nav-web class="mobile"></nav-web>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentSwiperItem: ""
    };
  },
  computed: {
    isNavActive() {
      return this.$route.path !== "/";
    },

    isNavActiveOfProduct() {
      return [
        "/keyCustomers",
        "/intelligentlogistics",
        "/chargingFranchise",
        "/transportationEnterprises",
        "/individualDriver",
        "/consignor",
        "/parkServices"
      ].includes(this.$route.path);
    },

    isNavAnchorActive() {
      return name => {
        return name === this.currentSwiperItem;
      };
    }
  },

  methods: {
    handleMenuMouseEnter(refName, popupRefName) {
      this.$refs["menu-submenu-popup__product"].style.display = "none";
      this.$refs["menu-submenu-popup__more-box"].style.display = "none";

      if (!refName) {
        return;
      }

      const $navbar = this.$refs.navbar;
      const $menuSubmenuPopup = this.$refs[popupRefName];
      const $el = this.$refs[refName];

      const top = $navbar.offsetHeight;
      const left = $el.offsetLeft;
      $menuSubmenuPopup.style.top = top + "px";
      // console.log($menuSubmenuPopup.offsetWidth, $el.offsetWidth);

      // if ($menuSubmenuPopup.offsetWidth < $el.offsetWidth) {
      //   $menuSubmenuPopup.style.width = $menuSubmenuPopup.offsetWidth + "px";
      // } else {
      //   $menuSubmenuPopup.style.width = $el.offsetWidth + "px";
      // }

      $menuSubmenuPopup.style.display = "block";
      if (
        left + $menuSubmenuPopup.offsetWidth >
        document.documentElement.offsetWidth
      ) {
        $menuSubmenuPopup.style.left =
          document.documentElement.offsetWidth -
          $menuSubmenuPopup.offsetWidth +
          "px";
      } else {
        $menuSubmenuPopup.style.left =
          left - $menuSubmenuPopup.offsetWidth / 4 + "px";
      }
    },

    handleSubmenuMouseLeave(popupRefName) {
      const $menuSubmenuPopup = this.$refs[popupRefName];

      $menuSubmenuPopup.style.display = "none";
    },

    handleChangeNavbar(name, index) {
      this.$router.push({
        path: "/",
        query: {
          anchor: name,
          anchorIndex: index
        }
      });
    }
  },

  mounted() {
    this.$bus.on("changeCurrentSwiperItem", name => {
      this.currentSwiperItem = name;
    });
    document.addEventListener("click", () => this.handleMenuMouseEnter());
  },

  beforeDestroy() {
    document.removeEventListener("click", () => this.handleMenuMouseEnter());
  }
};
</script>

<style lang="less">
@media screen and (max-width: 480px) {
  .navbar {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 480px) {
  .mobile {
    display: none;
  }
  .navbar {
    display: block;
  }

  .navbar {
    z-index: 9999;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 20px 50px;
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: space-between;

    #logo {
      img {
        width: 200px;
        transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
    }

    &.active {
      background: @navbar-bg;
    }
  }
  .menu2 {
    border-top: 1px solid #36426c;
  }
  .menu {
    white-space: nowrap;
    .icon-li {
      width: 40px;
      height: 40px;
      background-repeat: no-repeat;
      background-size: 90%;
      margin-top: 17px;
    }
    .icon-li01 {
      background-image: url("~@/assets/icon-li01.png");
    }
    .icon-li02 {
      background-image: url("~@/assets/icon-li02.png");
    }

    a {
      color: @navbar-menu-item;
      text-decoration: none;
      transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

      &:hover {
        color: @white;
      }
    }

    &&-horizontal &-item {
      display: inline-block;
    }

    &-item {
      position: relative;
      padding: 10px 30px;
      color: @navbar-menu-item;
      text-align: center;
      cursor: pointer;
      transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

      &:hover,
      &-selected {
        color: @white;
      }

      &-selected {
        &::before {
          position: absolute;
          display: block;
          content: "";
          left: 50%;
          bottom: 0;
          width: 20px;
          height: 2px;
          border-radius: 1px;
          background: linear-gradient(90deg, #099aff 0%, #3afefe 100%);
          transform: translate3d(-50%, 0, 0);
        }
      }

      &.menu-submenu {
        position: relative;
        &::after {
          display: inline-block;
          content: "";
          font-size: 0;
          padding: 0;
          vertical-align: middle;
          margin-left: 8px;
          box-sizing: border-box;
          border-width: 6px;
          border-style: solid;
          border-color: @navbar-menu-item transparent transparent transparent;
          transform: translate3d(0, 0, 0);
          transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        }

        &:hover::after {
          border-top-color: @white;
          transform: rotate(180deg) translate3d(0, 50%, 0);
        }
      }

      &.more-box {
        padding-right: 0;
        &::before {
          display: inline-block;
          content: "";
          position: absolute;
          height: 30%;
          width: 1px;
          top: 50%;
          left: 0;
          background: @navbar-menu-item;
          transform: translate3d(0, -50%, 0);
        }
      }
    }
  }
  .son-item {
    /*width: 100px;*/
    /*text-align: left;*/
    padding: 20px 10px;
    line-height: 2;
  }
  .menu-submenu-popup {
    display: none;
    position: absolute;
    background: fade(@navbar-submenu-bg, 90%);
    border-radius: 8px;
    padding: 20px;
  }
  .menu-submenu-popup-serve {
    padding: 0 30px;
    z-index: 1000;
  }

  .more-box-img {
    width: 20px;
    height: 20px;
    vertical-align: sub;
  }
}
</style>
